import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  // NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  BulkDeleteButton,
  CreateButton,
  ExportButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';

import LinkToList from './LinkToList';
// import CodeType from '../codeType';
// import EmissionType from '../emissionType';
// import MarkingType from '../markingType';
// import SerialNumType from '../serialNumType';
import CreateOrderButton from './CreateOrderButton';
import resourceLocales from './locales';
import resourceConfig from './config';
import directionType from '../directionType';
import docStatus from '../docStatus';
import docStatusSystem from '../docStatusSystem';
import DateInput from '../../../../components/DateInput';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import errorModel from '../errorModel';
import objectSendModel from '../objectSendModel';
import LoadButton from './LoadButton';
import exporter from '../../../../utils/exporter';
import goodUpload from '../goodUpload';
import PostPagination from '../../../../utils/pagination';
const ResourceIcon = BookmarkIcon;

const listStyles = {};

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <CreateOrderButton {...props} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'actionId'} />
    <TextInput source={'brand'} />
    <TextInput source={'creatorUsername'} />
    <directionType.Input source={'direction'} />
    <docStatus.Input source={'docStatus'} />
    <TextInput source={'docnum'} />
    <TextInput source={'documentId'} />
    <docStatusSystem.Input source={'documentSystemStatus'} />
    <TextInput source={'gtin'} />
    <TextInput source={'model'} />
    <TextInput source={'name'} />
    <TextInput source={'numgoods'} />
    <TextInput source={'owner_inn'} />
    <DateInput
      source={'processedDate'}
      label={`resources.${resourceConfig.name}.fields.processedDate`}
    />
    <TextInput source={'producer_inn'} />
    <TextInput source={'receiverId'} />
    <TextInput source={'requestId'} />
    <TextInput source={'subjectId'} />
    <TextInput source={'tnVedCode'} />

    <TextInput source={'packageType'} />
    <NumberInput source={'innerUnitCount'} />
    <NumberInput source={'publicationDate'} />
    <TextInput source={'inn'} />
    <TextInput source={'country'} />
    <TextInput source={'productTypeDesc'} />
    <TextInput source={'color'} />
    <TextInput source={'materialDown'} />
    <TextInput source={'materialUpper'} />
    <TextInput source={'materialLining'} />
    <TextInput source={'productType'} />

    <TextInput source={'ean'} />
  </Filter>
);

const ResourceListActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <goodUpload.OpenButton />
    <LoadButton />
    <CreateButton basePath={basePath} />
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    actions={<ResourceListActions />}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <TextField source={'brand'} />
      <TextField source={'gtin'} />
      <TextField source={'model'} />
      <TextField source={'name'} />
      <TextField source={'tnVedCode'} />
      <errorModel.LinkToRelatedList type={'GOODS'} />
      <objectSendModel.LinkToRelatedList type={'GOODS'} />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'actionId'} />
      <TextInput source={'brand'} />
      {/* <TextInput source={'companyUniqName'} /> */}
      <TextInput source={'creatorUsername'} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      {/* "documentLinkId": 0,
            "documentLinkType": "DOC", */}
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <TextInput source={'gtin'} />
      <TextInput source={'model'} />
      <TextInput source={'name'} />
      <TextInput source={'numgoods'} />
      <TextInput source={'owner_inn'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'producer_inn'} />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
      <TextInput source={'tnVedCode'} />

      <TextInput source={'packageType'} />
      <NumberInput source={'innerUnitCount'} />
      <NumberInput source={'publicationDate'} />
      <TextInput source={'inn'} />
      <TextInput source={'country'} />
      <TextInput source={'productTypeDesc'} />
      <TextInput source={'color'} />
      <TextInput source={'materialDown'} />
      <TextInput source={'materialUpper'} />
      <TextInput source={'materialLining'} />
      <TextInput source={'productType'} />
      <TextInput source={'productSize'} />

      <TextInput source={'ean'} />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm>
      <TextField source={'id'} />
      <TextInput source={'actionId'} />
      <TextInput source={'brand'} />
      {/* <TextInput source={'companyUniqName'} /> */}
      <TextInput source={'creatorUsername'} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      {/* "documentLinkId": 0,
            "documentLinkType": "DOC", */}
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <TextInput source={'gtin'} />
      <TextInput source={'model'} />
      <TextInput source={'name'} />
      <TextInput source={'numgoods'} />
      <TextInput source={'owner_inn'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'producer_inn'} />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
      <TextInput source={'tnVedCode'} />

      <TextInput source={'packageType'} />
      <NumberInput source={'innerUnitCount'} />
      <NumberInput source={'publicationDate'} />
      <TextInput source={'inn'} />
      <TextInput source={'country'} />
      <TextInput source={'productTypeDesc'} />
      <TextInput source={'color'} />
      <TextInput source={'materialDown'} />
      <TextInput source={'materialUpper'} />
      <TextInput source={'materialLining'} />
      <TextInput source={'productType'} />
      <TextInput source={'productSize'} />

      <TextInput source={'ean'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      processedDate: {
        type: 'dateTime',
      },
    },
  },
};
